import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API } from '../../services/api';
const api = new API();

export const fetchPins = createAsyncThunk(
  'pins/fetch',
  async (data, thunkAPI) => {
    try {
      const response = await api.getPins();
      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('pins/fetch', e);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
)

export const addPin = createAsyncThunk(
  'pins/add',
  async (data, thunkAPI) => {
    try {
      const response = await api.savePins([data]);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      // System error or status code >= 500
      console.error('pins/add', e);

      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

export const removePin = createAsyncThunk(
  'pins/remove',
  async (pinId, thunkAPI) => {
    try {
      const response = await api.deletePins([{id: pinId}]);

      if(response.status === 'ok') {
        return response.result;
      } else {
        return thunkAPI.rejectWithValue(response);
      }
    } catch(e) {
      console.error('pins/remove', e);
      return thunkAPI.rejectWithValue('INTERNAL_SERVER_ERROR');
    }
  }
);

const initialState = {
  pins: [],
  status: 'idle',
  error: null
};

export const pinsSlice = createSlice({
  name: 'pins',
  initialState,
  reducers: {
    clearRequestState: (state, action) => {
      state.error = null;
      state.status = 'idle';
    },
  },
  extraReducers: {
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchPins.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.pins = action.payload;
    },
    [fetchPins.pending]: (state, action) => {
      state.status = 'loading';
      state.error = null;
    },
    [fetchPins.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = {
        message: action.payload.messages.join(', ')
      };
    },

    [addPin.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.pins = action.payload;
    },
    [addPin.pending]: (state, action) => {
      state.status = 'loading';
      state.error = null;
    },
    [addPin.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = {
        message: action.payload.messages.join(', ')
      };
    },
    [removePin.fulfilled]: (state, action) => {
      state.status = 'succeeded';
      state.error = null;
      state.pins = action.payload || [];
    },

    [removePin.pending]: (state, action) => {
      state.status = 'loading';
      state.error = null;
    },
    [removePin.rejected]: (state, action) => {
      state.status = 'failed';
      state.error = {
        message: action.payload.messages.join(', ')
      };
    },
  }
});

export const { clearRequestState } = pinsSlice.actions;

export const selectPins = state => state.pins;

export const selectPinsByOwner = state => ({
  pins: state.pins.pins.filter(item => item.itemOwner === state.itemOwners.selected),
  status: state.pins.status,
  error: state.pins.error
});

export default pinsSlice.reducer;
